import { writable } from "svelte/store";
import { FUNBOX_SERVICE_URL, MONITOR_URL_TEMPLATE, SERVICE_URL, WS_SERVICE_URL } from "../environment";
import { AccountsFactory } from "./AccountsFactory";
import { AccountsService } from "./AccountsService";
import { AuthorizationService } from "./AuthorizationService";
import { BoardsFactory } from "./BoardsFactory";
import { BoardsService } from "./BoardsService";
import { EventsChannelFactory } from "./EventsChannelFactory";
import { GamesFactory } from "./GamesFactory";
import { GamesService } from "./GamesService";
import { HttpService } from "./HttpService";
import { HttpFunboxService } from "./HttpFunboxService";
import { LoginService } from "./LoginService";
import { MeService } from "./MeService";
import { MessagesFactory } from "./MessagesFactory";
import { MessagesService } from "./MessagesService";
import { MonitorScreenService } from "./MonitorScreenService";
import { PicturesService } from "./PicturesService";
import { PictureUrlFactory } from "./PictureUrlFactory";
import { PlayersFactory } from "./PlayersFactory";
import { PlayersService } from "./PlayersService";
import { QueryParamsFactory } from "./QueryParamsFactory";
import { RealTimeService } from "./RealTimeService";
import { ReloadService } from "./ReloadService";
import { RoomsFactory } from "./RoomsFactory";
import { RoomsService } from "./RoomsService";
import { UserFactory } from "./UserFactory";
import { UsersService } from "./UsersService";
import { UuidGenerator } from "./UuidGenerator";
import { GameTypeService } from "./GameTypeService";
const monitorScreenService = new MonitorScreenService(MONITOR_URL_TEMPLATE);
const uuidGenerator = new UuidGenerator();
const pictureUrlFactory = new PictureUrlFactory(SERVICE_URL);
const authorizationService = new AuthorizationService('access_token');
const httpService = new HttpService(SERVICE_URL, authorizationService);
const httpFunboxService = new HttpFunboxService(FUNBOX_SERVICE_URL, authorizationService);
const queryParamsFactory = new QueryParamsFactory();
const usersService = new UsersService(httpService /* httpFunboxService */, queryParamsFactory);
const meService = new MeService(authorizationService, usersService);
const realTimeService = new RealTimeService(WS_SERVICE_URL);
const eventsChannelsFactory = new EventsChannelFactory(realTimeService);
const roomsFactory = new RoomsFactory(eventsChannelsFactory);
const gamesFactory = new GamesFactory(eventsChannelsFactory);
const playersFactory = new PlayersFactory(eventsChannelsFactory);
const userFactory = new UserFactory();
const loginService = new LoginService(httpService, authorizationService);
const roomsService = new RoomsService(httpService, roomsFactory, gamesFactory, playersFactory);
const gamesService = new GamesService(httpService, gamesFactory);
const accountsFactory = new AccountsFactory();
const accountsService = new AccountsService(httpService, accountsFactory, userFactory);
const picturesService = new PicturesService(uuidGenerator, SERVICE_URL);
const boardsFactory = new BoardsFactory(eventsChannelsFactory);
const boardsService = new BoardsService(httpService, boardsFactory);
const playersService = new PlayersService(httpService);
const messagesFactory = new MessagesFactory(uuidGenerator);
const messagesService = new MessagesService(httpService, messagesFactory);
const reloadService = new ReloadService(httpService);
const playingMusic = writable(false);
export { uuidGenerator, authorizationService, usersService, userFactory, loginService, roomsService, roomsFactory, meService, gamesService, gamesFactory, eventsChannelsFactory, playersFactory, accountsFactory, accountsService, picturesService, realTimeService, pictureUrlFactory, boardsService, boardsFactory, playersService, messagesFactory, messagesService, monitorScreenService, reloadService, playingMusic, httpFunboxService, GameTypeService };
